import { ChevronRight } from 'lucide-react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';

import SmallSpinner from '@/components/shared/spinners/small-spinner';
import { useContracts, useSelectedContract } from '@/hooks/api/use-contracts';
import usePageTitle from '@/hooks/use-page-title';

import Contract from '@/pages/contract/contract-routes';
import ListeContracts from '@/pages/contract/liste-contracts';

const Contracts = () => {
    usePageTitle('Mes contrats');
    const contractsQuery = useContracts();
    const police = useSelectedContract()?.numeroPolice;
    const params = useLocation().pathname.split('/');

    if (contractsQuery.isPending) return <SmallSpinner />;

    return (
        <div className={'w-full'}>
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3.5 h-3.5" />
                <Link to="/mes-contrats" className="hover:text-foreground transition-colors no-underline">Mes contrats</Link>
                {params.length >= 4 && police && (
                    <>
                        <ChevronRight className="w-3.5 h-3.5" />
                        <span className="text-foreground font-medium">Contrat N°{police}</span>
                    </>
                )}
            </nav>

            <Routes>
                <Route index element={<ListeContracts />} />
                <Route path={'mon-contrat/:id/*'} element={<Contract />} />
            </Routes>
        </div>
    );
};

export default Contracts;
